import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import {Offset} from '../../../models/Offset';
import {NumAnnoMeseService} from '../../general-services/service-num-anno-mese/num-anno-mese.service';
import { MatDialog } from '@angular/material/dialog';
import {GenericArray} from '../../../models/GenericArray';
import {DialogYearMonthComponent} from '../../general-components/dialog-year-month/dialog-year-month.component';
import {TerminationFeeModel} from '../../../models/TerminationFeeModel';
import {ProviderModel} from '../../../models/ProviderModel';

@Component({
  selector: 'app-quotation-termination-fee',
  templateUrl: './quotation-termination-fee.component.html',
  styleUrls: ['./quotation-termination-fee.component.scss']
})
export class QuotationTerminationFeeComponent  extends BaseGeneralComponent implements OnInit, OnChanges, OnDestroy {
  offset: Offset;
  filter: TerminationFeeModel;
  numAnnoMeseData: any;

  constructor(private numAnnoMeseService: NumAnnoMeseService,
              private dialog: MatDialog) {
    super();

    this.filter = new TerminationFeeModel();
    this.init();
  }

  init(){
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;
    this.numAnnoMeseService.getAllMonth(this.filter.provider, this.filter.contractType).subscribe(
      (resultYearMonth: any) => {
        const providerDefault = this.filter.provider;
        this.numAnnoMeseData = this.filterFromDxc(providerDefault, resultYearMonth);

        // tslint:disable-next-line:max-line-length
        if (!this.filter.numAnnoMese || !BaseGeneralComponent.isNumAnnoMeseInFilterList(this.filter.numAnnoMese, this.numAnnoMeseData)) {
          const numAnnoMese = this.numAnnoMeseData[0] ? this.numAnnoMeseData[0] : null;
          this.filter.numAnnoMese = numAnnoMese;
        }
      }, error => {
        console.log(error);
      });
  }

  openDialogDownloadXlsxQuotation() {
    const list: GenericArray[] = [
        {id: 'filter', value: this.filter},
        {id: 'offset', value: this.offset},
        {id: 'numAnnoMeseData', value: this.numAnnoMeseData},
        {id: 'serviceReportPage', value: this.SERVICE_REPORT_DOWNLOAD.TERMINATION_FEE_SERVICE},
        {id: 'quotationRequest', value: true}
      ],
      dialogRef = this.dialog.open(DialogYearMonthComponent, {
        data: {list}
      });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnDestroy(): void {
  }

}
